import React, { useEffect, useRef, useState } from 'react'
import { Spinner, Alert } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import { connect, useSelector } from 'react-redux'
import { fetchUserByOpportunityId } from 'application/actions/userActions'
import { receiveOpportunityId } from 'application/actions/opportunityActions'
import { detectBrowser } from 'application/actions/browserActions'
import { sendAccessCode } from 'application/actions/authenticationActions'
import { ValidateCaptcha } from 'application/actions/captchaActions'
import withLocation from 'application/components/withLocation'
import ReCAPTCHA from 'react-google-recaptcha'
import AppInMaintenance from 'application/components/pages/login'
import { MdErrorOutline } from 'react-icons/md'
import { PrimaryButton } from '@mmsg/louie'
import * as E from 'application/components/pages/login/loginElements'

const LoginOptionForm = ({
  setCanEnterCode,
  option,
  handleOptionChange,
  search,
  dispatch,
  isFetchingUser,
  email,
  mobile,
  opportunityId,
  isRequestingAccessCode,
  applicationMaintenanceStatus,
  errorMessage,
  changedOption,
  updateChangedOption,
}) => {
  const setBrowser = () => {
    dispatch(detectBrowser())
  }

  useEffect(() => {
    if (!changedOption) {
      setBrowser()

      if (search.oppId) {
        dispatch(receiveOpportunityId(search.oppId))
        dispatch(fetchUserByOpportunityId(search.oppId))
      }
    }
  }, [])

  document.cookie = 'oppId=' + search.oppId

  const [smsActive, setSMSActive] = useState(option == 'mobile')
  const recaptchaRef = useRef()
  const sendVerificationCodeErrorMessage = useSelector(
    (state) => state.accessCode.errorMessage
  )

  const { outdatedBrowser } = useSelector((state) => ({ ...state.browser }))

  const sendCodeHandler = async (event) => {
    recaptchaRef.current.reset()
    const token = await recaptchaRef.current.executeAsync()
    dispatch(sendAccessCode(opportunityId, option, token)).then(() => {
      setCanEnterCode(true)
    }, updateChangedOption(false))
  }

  const OnValidatingForCaptcha = async () => {
    const token = await recaptchaRef.current.executeAsync()
    recaptchaRef.current.reset()
    dispatch(ValidateCaptcha(token, dispatch))
  }

  const handleKeyDown = (e, val) => {
    if (e.key === 'Enter') {
      let medium = {
        target: {
          value: val,
        },
      }
      handleOptionChange(medium)
    }
  }

  const captcha = useSelector((state) => state.captcha)

  const spinner = <Spinner animation="border" size="sm" />
  const isError = !!errorMessage || (!search.oppId && !opportunityId)
  let variableText =
    'Before we step you through your ' +
    (global.config.brand == 'Maxxia'
      ? 'novated lease options'
      : 'estimated tax savings (not to mention your shiny new car options)') +
    ' we need to verify your identity.'

  let variableText2 =
    'Choose where you' +
    (global.config.brand == 'Maxxia' ? '’d like' : ' want') +
    ' to receive your one-time verification code below. Then you’ll be on the road to browsing convenient and ' +
    (global.config.brand == 'RemServ' ? 'potential ' : '') +
    'tax-effective benefits in no time.'

  const onClickHander = () => {
    setSMSActive(!smsActive)
  }

  return isError ? (
    <Alert variant="danger">
      {errorMessage}
      {!search.oppId && !opportunityId && <>opportunityId is not provided</>}
    </Alert>
  ) : (
    <>
      {/*To load the landing page when there is a application maintenance page to be loaded*/}
      {applicationMaintenanceStatus &&
        applicationMaintenanceStatus.isApplicationOnMaintenance && (
          <>
            <AppInMaintenance
              maintenanceTitle={applicationMaintenanceStatus.maintenanceTitle}
              maintenanceMessage={
                applicationMaintenanceStatus.maintenanceMessage
              }
            />
          </>
        )}

      {/*To load the login page when there is no application maintenance component to be loaded*/}
      {applicationMaintenanceStatus &&
        !applicationMaintenanceStatus.isApplicationOnMaintenance && (
          <Form className="text-center">
            <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            />
            {outdatedBrowser ? (
              <Alert
                variant="danger"
                className="text-left mt-0 w-100"
                id="loginoptionform.outdatedbrowseralert"
              >
                <MdErrorOutline
                  color="#AD240A"
                  size={`1.6em`}
                  style={{
                    minWidth: '20px',
                    position: 'absolute',
                    left: '6px',
                    top: '11px',
                  }}
                />
                <div className="text-small ml-3">
                  <div className="mb-1">
                    <b id="loginoptionform.outdatedbrowser">
                      This website works best in the latest versions of Chrome,
                      Edge, Firefox, and similar browsers. You may not have the
                      best experience on your current browser or device.
                    </b>
                  </div>
                </div>
              </Alert>
            ) : null}
            <E.heading>Choose your security method</E.heading>
            <E.body className="mt-4">{variableText}</E.body>
            <E.body>{variableText2}</E.body>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'left',
                marginBottom: '30px',
              }}
            >
              <label for="mobile">
                <E.RadioOptionDiv
                  id="loginoptionform.mobilediv"
                  isActive={smsActive}
                  tabIndex="0"
                  onKeyDown={(e) => handleKeyDown(e, 'mobile')}
                >
                  <E.testRadio
                    type="radio"
                    id="mobile"
                    name="contact"
                    value="mobile"
                    tabIndex="-1"
                    disabled={isFetchingUser}
                    onChange={handleOptionChange}
                    checked={smsActive ? 'checked' : null}
                    onClick={!smsActive && onClickHander}
                  />
                  <E.labelDiv>
                    <E.ReceiveOptionsP>
                      Receive by SMS (recommended)
                    </E.ReceiveOptionsP>
                    <E.ReceiveOptionsP id="loginoptionform.sendtomobile">
                      Send code to {isFetchingUser ? spinner : mobile}
                    </E.ReceiveOptionsP>
                  </E.labelDiv>
                </E.RadioOptionDiv>
              </label>
              <label for="email">
                <E.RadioOptionDiv
                  id="loginoptionform.emaildiv"
                  isActive={!smsActive}
                  tabIndex="0"
                  onKeyDown={(e) => handleKeyDown(e, 'email')}
                >
                  <E.testRadio
                    type="radio"
                    id="email"
                    name="contact"
                    value="email"
                    tabIndex="-1"
                    disabled={isFetchingUser}
                    checked={!smsActive ? 'checked' : null}
                    onChange={handleOptionChange}
                    onClick={smsActive && onClickHander}
                  />
                  <E.labelDiv>
                    <E.ReceiveOptionsP>Receive by email</E.ReceiveOptionsP>
                    <E.ReceiveOptionsP id="loginoptionform.sendtoemail">
                      Send code to {isFetchingUser ? spinner : email}
                    </E.ReceiveOptionsP>
                  </E.labelDiv>
                </E.RadioOptionDiv>
              </label>
            </div>

            {isRequestingAccessCode && (
              <PrimaryButton extendInMob disabled={isFetchingUser}>
                <>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="mb-1"
                  />
                  Sending...
                </>
              </PrimaryButton>
            )}
            {!isRequestingAccessCode && (
              <>
                <PrimaryButton
                  onClick={sendCodeHandler}
                  disabled={isFetchingUser}
                  extendInMob
                  id="loginoptionform.sendbutton"
                >
                  Send verification code
                </PrimaryButton>
              </>
            )}
            {sendVerificationCodeErrorMessage &&
              sendVerificationCodeErrorMessage !== '' &&
              !changedOption && (
                <div className="mt-3">
                  <Alert variant="danger" id="loginoptionform.error">
                    {sendVerificationCodeErrorMessage}
                  </Alert>
                </div>
              )}
          </Form>
        )}
    </>
  )
}

function mapStateToProps(state) {
  const {
    isFetching: isFetchingUser,
    email,
    mobile,
    applicationMaintenanceStatus,
    errorMessage,
  } = state.user
  const { opportunityId } = state.opportunity
  const { isFetching: isRequestingAccessCode } = state.accessCode

  return {
    isFetchingUser,
    email: email,
    mobile: mobile,
    opportunityId,
    isRequestingAccessCode,
    applicationMaintenanceStatus,
    errorMessage,
  }
}

export default connect(mapStateToProps)(withLocation(LoginOptionForm))
